module.exports = __webpack_public_path__ + "fonts/DINPro-CondIta.8c829deb.otf";